module.exports = __webpack_public_path__ + "open-sans-latin-600italic.80dbc33fd1806f83a9d7.woff";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600italic.woff
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600italic.woff
// module chunks = 1 3